import React from 'react'
import { Root } from './Styled'
import { NewCelebrationForm } from '@octanner/yearbook-program-settings'
import { useHistory } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'

type Props = { programId: string; customerUuid: string }

const NewCelebrationWrapper: React.FC<Props> = ({
  programId,
  customerUuid,
}) => {
  const history = useHistory()
  const onReroute = () => () => {
    history.push(`/program-settings/${programId}`)
  }
  const { ccAdminCcybYearbookManageCelebration20250319 } = useFlags()
  return (
    <Root>
      <NewCelebrationForm
        programId={programId}
        customerUuid={customerUuid}
        onReroute={onReroute()}
        launchDarklyFlags={[
          {
            key: 'ccAdminCcybYearbookManageCelebration20250319',
            value: ccAdminCcybYearbookManageCelebration20250319,
          },
        ]}
      />
    </Root>
  )
}

export default NewCelebrationWrapper
